<template>
  <div class="email-input-container">
    <label for="user_email">{{labelText}}</label>
    <input 
        :id="inputId"
        :name="inputId"
        :placeholder="placeholder"
        type="email"
        v-model="emailValue"
        @change="validateEmail" />
    <div v-if="errorMessage" class="input-error">{{errorMessage}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      fieldToReturn: String,
      inputId: [Number, String],
      labelText: String,
      placeholder: String,
    },

    name: 'EmailInput',

    data() {
      return {
        emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        emailValue: null,
        errorMessage: null,
      }
    },

    methods: {
      validateEmail() {
        const emptyInput = this.emailValue.length === 0,
            invalidFormat = !this.emailRegex.test(this.emailValue),
            invalidEmail = emptyInput || invalidFormat,
            error = invalidEmail ? 'invalid email' : null,
            value = invalidEmail ? '' : this.emailValue

        this.errorMessage = error
        this.setEmail(value)
      },

      setEmail(value) {
        this.$emit('setEmail', this.fieldToReturn, value)
      }
    }
  }
</script>
